import { APIClient } from '@frontend/api-utils';
import { HeatmapChartData } from '@frontend/chart/types';

export class ProductChartClient extends APIClient {
    public static readonly endpoint = '/product-api/v1';

    public static async fetchAvailableSlots(accountId: string, spotId: string, moduleId: string, productId: string): Promise<HeatmapChartData> {
        const response = await this.fetchWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/products/${productId}/available-slots`
        );
        return await this.handleResponse<HeatmapChartData>(response);
    }
}
